<template>
  <v-layout row wrap>
    <v-flex xs12 sm12>
      <v-toolbar flat color="white" class="mb-3">
        <v-tooltip bottom>
          <v-btn icon @click="$router.go(-1)" slot="activator">
            <v-icon color="white">arrow_back</v-icon>
          </v-btn>

          <span>{{ $vuetify.t('$vuetify.app.back') }}</span>
        </v-tooltip>

        <v-toolbar-title>
          Offline Requests
        </v-toolbar-title>
      </v-toolbar>
    </v-flex>
    <v-flex xs12 sm12>
      <v-list>
        <template v-if="offlineRequests.length">
          <v-list-tile
            ripple
            v-for="request in offlineRequests"
            :key="request.id"
          >
            <v-list-tile-action>
              {{ request.id }}
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ request.type }}</v-list-tile-title>
              <v-list-tile-sub-title>{{
                request.objectId
              }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
        <template v-else>
          <div class="text-center">No offline requests found</div>          
        </template>
      </v-list>
      <div class="text-center">
        <v-btn
          @click.native="sendOfflineRequest"
          color="green"
          v-if="offlineRequests.length"
        >
          Send the Request again
        </v-btn>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>

export default {
  data() {
    return {
      offlineRequests: []
    }
  },
  methods: {
    async sendOfflineRequest() {
      const registration = await navigator.serviceWorker.ready
      await registration.sync.register('offline-requests')
      this.processRequests()
    },
    processRequests() {
      indexedDB.open('trios').onsuccess = function(event) {
        var db = event.target.result
        var transaction = db.transaction(['offlineRequests'], 'readwrite')
        var objectStore = transaction.objectStore('offlineRequests')
        var request = objectStore.getAll()
        request.onsuccess = function(event) {
          this.offlineRequests = request.result
        }.bind(this)
      }.bind(this)
    }
  },
  created() {
    this.processRequests()
  }
}
</script>
